import apiClient from '../utils/apiClient';

// Fetch employees for timesheet dropdown
export async function getTimesheetEmployees(params = {}) {
    const response = await apiClient.get('/api/timesheets/employees', { params });
    return response.data.employees;
}

export async function updateTimesheetEmployeeVisibility(employeeId, hidden) {
    const response = await apiClient.put(`/api/timesheets/employees/${employeeId}/visibility`, { hidden });
    return response.data;
}

// Fetch all timesheets for a specific user
export async function fetchTimesheets(filters = {}) {
    // Build query params from filters object
    const params = {};
    if (filters.userId) params.userId = filters.userId;
    if (filters.employee_id) params.employee_id = filters.employee_id;
    if (filters.project_id) params.project_id = filters.project_id;
    if (filters.start_date) params.start_date = filters.start_date;
    if (filters.end_date) params.end_date = filters.end_date;

    const response = await apiClient.get('/api/timesheets', { params });
    return response.data;
}

const WEEK_PARAMS = (weekStart) => ({ week_start: weekStart, today: new Date().toLocaleDateString('en-CA') });

// Everyone's week (status, logged, scheduled, billable, missing) for the Team table.
export async function getTimesheetWeeks(weekStart) {
    const response = await apiClient.get('/api/timesheets/weeks', { params: WEEK_PARAMS(weekStart) });
    return response.data;
}

// One person's week: lines, what Schedule booked, leave and the week's status.
export async function getTimesheetGrid(employeeId, weekStart) {
    const response = await apiClient.get('/api/timesheets/grid', { params: { ...WEEK_PARAMS(weekStart), employee_id: employeeId } });
    return response.data;
}

// Sets (or, with mode "add", adds to) one line's hours on one day; 0 clears the cell.
export async function saveTimesheetCell(cell) {
    const response = await apiClient.post('/api/timesheets/grid/cell', cell);
    return response.data;
}

// action: 'billable' (needs is_billable) or 'remove', for a whole line in one week.
export async function changeTimesheetLine(line) {
    const response = await apiClient.post('/api/timesheets/grid/line', line);
    return response.data;
}

// action: submit | approve | send_back | reopen | restore | remind. Returns { updated, previous } so callers can offer Undo.
export async function decideTimesheetWeeks(decision) {
    const response = await apiClient.post('/api/timesheets/weeks/decision', decision);
    return response.data;
}
